import styled from 'styled-components'

export const LegalDeclarationPageWrapper = styled.div`
  #ShortDeclaration {
    cursor: pointer;
    font-weight: ${(props) => props.theme.fontWeight} !important;

    ul {
      padding: 15px;
      color: ${({ theme }) => theme.primaryTextColour} !important;
      font-size: ${(props) => props.theme.generalFontSize} !important;
    }
    ul li ul li {
      list-style: disc;
      margin-bottom: 8px;
    }
    li {
      text-align: left;
      list-style: none;
      font-family: ${(props) => props.theme.LegalDecsfontFamily};
      font-style: ${(props) => props.theme.fontStyle};
      font-weight: ${(props) => props.theme.fontWeight};
      font-size: ${(props) => props.theme.generalFontSize};
    }
  }

  #DisallowedOccupationsLink {
    color: ${(props) => props.theme.primaryColour};
    display: inline;
    cursor: pointer;
    text-decoration: underline;
  }
`
